type Callback = () => void;
class NbnSubject {
    private observers: Callback[] = [];
    private shouldNotify: boolean = true;

    public register = (cb: Callback): void => {
        this.observers.push(cb);
    };

    public notify = (): void => {
        if (!this.shouldNotify) return;

        this.observers.forEach((observer) => observer());
        this.shouldNotify = false;
    };
}

interface Window {
    nbnSubject: NbnSubject;
    nbnQuickPicksSubject: NbnSubject;
}

window.nbnSubject = window.nbnSubject || new NbnSubject();
window.nbnQuickPicksSubject = window.nbnQuickPicksSubject || new NbnSubject();
